import { secureIP } from '../../features/ip/secure.types';
import { createSlice } from '@reduxjs/toolkit';
interface ModalState {
  isOpened: boolean;
  type: string | null;
  extra: {
    email?: string;
    id?: string;
    title?: string;
    supportText?: string;
    subSupportText?: string;
    actionButtonText?: string;
    actionButtonColor?: string;
    data?: secureIP;
    handler?: () => void | Promise<void>;
    settingsHandler?: (id: string, checked: boolean) => void;
    imagesHandler?: (id: string) => void;
    link?: string;
    fileName?: string;
    textInformation?: string;
    userRole?: string;
    checked?: boolean;
  } | null;
}

const initialState: ModalState = {
  isOpened: false,
  type: null,
  extra: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, { payload }) => {
      const { type, extra } = payload;
      state.isOpened = true;
      state.type = type;
      state.extra = extra ?? null;
    },
    closeModal: (state) => {
      state.isOpened = false;
      state.type = null;
      state.extra = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
